import { Validator } from '@vista-digital/validator';
import { SeatPickerLegend } from '../../../subcomponents/seat-picker/subcomponents/legend';
import { reactComponentValidator } from '../../../validators/react-component';
export const defaultShowTimeSeatPreviewSubcomponents = {
    SeatPickerLegend: SeatPickerLegend
};
export const showTimeSeatPreviewSubcomponentsValidator = Validator.object({
    SeatPickerLegend: reactComponentValidator
});
//# sourceMappingURL=subcomponents.js.map